import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../http-client/http-client.service';
import { Service } from '../service';
import { Observable } from 'rxjs/Observable';
import { ExamBoard } from '../../models/exam-boards/exam-board';

@Injectable()
export class ExamBoardService extends Service {
    private apiUrl = 'ExamBoard/';

    constructor(private http: HttpClientService) {
        super();
    }

    public getByExamCall(examCallId: number, shiftId?: number, subjectId?: number): Observable<ExamBoard[]> {
        let url = this.apiUrl + 'GetByExamCall/' + examCallId;
        console.log("Getting exam boards for exam call: ", examCallId, " shift: ", shiftId, " subject: ", subjectId);
        const params = [];
        if (shiftId) params.push(`shiftId=${shiftId}`);
        if (subjectId) params.push(`subjectId=${subjectId}`);
        if (params.length > 0) url += '?' + params.join('&');
        //return this.http.get<ExamBoard[]>(url);

        return this.http.get(url).map(response => {
            const r = response.json();
            return r;
        }).catch(this.handleError);
    }

    add(examBoard: any): Observable<any> {
        return this.http.post(this.apiUrl + 'Add', examBoard).map(response => response.json());
    }

    update(examBoard: any): Observable<any> {
        return this.http.put(this.apiUrl + 'Update', examBoard).map(response => response.json());
    }

    delete(id: number): Observable<any> {
        return this.http.delete(this.apiUrl + 'Delete/' + id).map(response => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/exam-board/exam-board.service.ts